import { ImgComparisonSlider } from "@img-comparison-slider/react";
import SectionWrapper, { Container } from "./beforeAfter.style";
import Fade from 'react-reveal/Fade';
import React from 'react';

// Custom high-quality inline SVG icons matching mockup using currentColor
const SparklesIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 3C9 5.5 11 7.5 13.5 7.5C11 7.5 9 9.5 9 12C9 9.5 7 7.5 4.5 7.5C7 7.5 9 5.5 9 3Z" fill="currentColor" />
    <path d="M17 11C17 12.8 18.5 14.3 20.3 14.3C18.5 14.3 17 15.8 17 17.6C17 15.8 15.5 14.3 13.7 14.3C15.5 14.3 17 12.8 17 11Z" fill="currentColor" />
    <path d="M7 15C7 16.1 7.9 17 9 17C7.9 17 7 17.9 7 19C7 17.9 6.1 17 5 17C6.1 17 7 16.1 7 15Z" fill="currentColor" />
  </svg>
);

const WalletIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 12V8H6a2 2 0 0 1-2-2c0-1.1.9-2 2-2h12v4" />
    <path d="M4 6v12a2 2 0 0 0 2 2h14v-4" />
    <path d="M18 12a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h4v-6Z" />
  </svg>
);

const NaturalIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M19 8l2 2-2 2" />
    <path d="M17 10h4" />
  </svg>
);

const RemoveIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 10V5.5C9 4.67 9.67 4 10.5 4C11.33 4 12 4.67 12 5.5V11H13V7.5C13 6.67 13.67 6 14.5 6C15.33 6 16 6.67 16 7.5V11H17V9.5C17 8.67 17.67 8 18.5 8C19.33 8 20 8.67 20 9.5V16C20 19.31 17.31 22 14 22H11C7.69 22 5 19.31 5 16V13C5 12.17 5.67 11.5 6.5 11.5C7.33 11.5 8 12.17 8 13V11H9Z" />
    <path d="M12 1.5V3" />
    <path d="M7.5 2.5L8.5 4" />
    <path d="M16.5 2.5L15.5 4" />
  </svg>
);

const MaintenanceIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 6L9 17L4 12" />
  </svg>
);

const BeforeAfter = () => {
  return (
    <SectionWrapper id="beforeAfter">
      <Container>
        {/* Section Header */}
        <div className="section-header">
          <Fade bottom cascade>
            <span className="subtitle">Why Choose</span>
            <h3 className="title">
              Hair Patch <span className="btn_heading">Solutions?</span>
            </h3>
            <div className="title-divider">
              <span className="dot" />
            </div>
            <p className="description">
              Smart, natural and hassle-free hair solutions for a confident you.
            </p>
          </Fade>
        </div>

        {/* 3-Column Content Layout */}
        <div className="main-content-grid">
          {/* Left Column - Enhanced Appearance & Natural Looking */}
          <div className="left-column">
            <Fade left delay={100}>
              <a href="services.php" className="feature-card align-left">
                <div className="icon-badge">
                  <SparklesIcon />
                </div>
                <h4 className="card-title">Enhanced Appearance</h4>
                <p className="card-desc">
                  Gives you a fuller, thicker and more confident look instantly.
                </p>
              </a>
            </Fade>

            <Fade left delay={300}>
              <a href="services.php" className="feature-card align-left">
                <div className="icon-badge">
                  <NaturalIcon />
                </div>
                <h4 className="card-title">Natural Looking</h4>
                <p className="card-desc">
                  Blends seamlessly with your natural hair for a realistic and undetectable finish.
                </p>
              </a>
            </Fade>
          </div>

          {/* Center Column - Circular Image & Low Maintenance */}
          <div className="center-column">
            {/* Center head wrapper containing image and concentric circles */}
            <Fade bottom delay={200}>
              <div className="slider-circle-wrapper">
                {/* Concentric orbital rings and warm orange gradient glow background */}
                <div className="center-bg-glow" />
                <div className="center-bg-lines">
                  <div className="circle" />
                  <div className="circle" />
                  <div className="circle" />
                  <div className="dot-marker dot-1" />
                  <div className="dot-marker dot-2" />
                  <div className="dot-marker dot-3" />
                  <div className="dot-marker dot-4" />
                </div>

                <div className="slider-circle" style={{ borderRadius: '50%', overflow: 'hidden' }}>
                  <ImgComparisonSlider hover="hover">
                    <img slot="first" src="/home/after.png" alt="before" />
                    <img slot="second" src="/home/before.png" alt="after" />
                  </ImgComparisonSlider>
                </div>
              </div>
            </Fade>

            {/* Low Maintenance Bottom Card */}
            <Fade bottom delay={400}>
              <a href="services.php" className="wide-bottom-card">
                <div className="icon-badge">
                  <MaintenanceIcon />
                </div>
                <div className="card-content">
                  <h4 className="card-title">Low Maintenance</h4>
                  <p className="card-desc">
                    Requires minimal care and styling, saving you time and effort every day.
                  </p>
                </div>
              </a>
            </Fade>
          </div>

          {/* Right Column - Cost Effective & Easy to Remove */}
          <div className="right-column">
            <Fade right delay={100}>
              <a href="services.php" className="feature-card align-right">
                <div className="icon-badge">
                  <WalletIcon />
                </div>
                <h4 className="card-title">Cost Effective</h4>
                <p className="card-desc">
                  A budget-friendly solution that delivers great results without breaking the bank.
                </p>
              </a>
            </Fade>

            <Fade right delay={300}>
              <a href="services.php" className="feature-card align-right">
                <div className="icon-badge">
                  <RemoveIcon />
                </div>
                <h4 className="card-title">Easy to Remove</h4>
                <p className="card-desc">
                  Can be removed easily and comfortably whenever you want.
                </p>
              </a>
            </Fade>
          </div>
        </div>

        {/* Feature Footer Bar */}
        <Fade bottom delay={500}>
          <div className="footer-feature-bar">
            <div className="feature-item">
              <span className="check-icon"><CheckIcon /></span>
              <span className="feature-text">Comfortable Fit</span>
            </div>
            <div className="divider" />
            <div className="feature-item">
              <span className="check-icon"><CheckIcon /></span>
              <span className="feature-text">Durable & Long Lasting</span>
            </div>
            <div className="divider" />
            <div className="feature-item">
              <span className="check-icon"><CheckIcon /></span>
              <span className="feature-text">Boosts Confidence</span>
            </div>
            <div className="divider" />
            <div className="feature-item">
              <span className="check-icon"><CheckIcon /></span>
              <span className="feature-text">Suitable for All Ages</span>
            </div>
          </div>
        </Fade>
      </Container>
    </SectionWrapper>
  );
};

export default BeforeAfter;
